import React from 'react'
import Retry from './download.jpg'

class Sroce extends React.Component{
     


    render(){
        return(
<img src={Retry} alt='hhh' onClick={this.props.onClick} />
            )
    }
}

export default Sroce;